<template>
    <div class="relative">
        <div class="vx-navbar-wrapper nav-menu-wrapper">
            <vs-navbar
                class="vx-navbar navbar-custom navbar-skelton custom-nav-height"
                :color="navbarColor"
            >
                <ul class="menu-items flex flex-wrap w-full items-center">
                    <li
                        class="menu-item"
                        v-for="(item, index) in nav_menu_items"
                        :key="index"
                        :class="{
                            'mr-2': !(nav_menu_items.length === index + 1)
                        }"
                    >
                        <!-- If header -->
                        <template v-if="item.header">
                            <h-nav-menu-header :header="item" class="menu-header relative" />
                        </template>

                        <!-- If it's group -->
                        <template v-else-if="item.submenu">
                            <h-nav-menu-group
                                class="menu-group relative py-4"
                                bottom
                                :key="`group-${index}`"
                                :group="item"
                                :groupIndex="index"
                                :open="checkGrpChildrenActive(item)"
                            />
                        </template>

                        <!-- If it's link -->
                        <div v-else-if="item.url" class="menu-link">
                            <h-nav-menu-item
                                class="relative py-4 cursor-pointer"
                                :to="item.slug !== 'external' ? item.route : null"
                                :href="item.slug === 'external' ? item.url : null"
                                :icon="item.icon"
                                :target="item.target"
                                :isDisabled="item.isDisabled"
                                :slug="item.slug"
                            >
                                <span class="truncate">{{ item.name }}</span>
                                <vs-chip :color="item.tagColor" v-if="item.tag">{{
                                    item.tag
                                }}</vs-chip>
                            </h-nav-menu-item>
                        </div>
                    </li>
                    <li style="display: flex !important; flex-grow: 1">&nbsp;</li>
                    <li>
                        <span
                            v-if="
                                has_role('Content_Creator') &&
                                !edition.isPublishing &&
                                edition.nonScheduledItems
                            "
                            class="mr-5"
                        >
                            {{ itemsScheduled }}
                            Queued for Publishing
                        </span>
                    </li>
                    <li></li>
                    <li
                        style="display: flex !important; justify-self: end"
                        v-if="has_role('Content_Creator')"
                    >
                        <div class="flex" v-if="edition.isPublishing && edition.items">
                            <div v-if="edition.isPublishing && edition.startedPublishing">
                                <span class="mr-5">
                                    {{ publishedItemCount }}
                                    /
                                    {{ itemsToPublish }}
                                    Publishing
                                </span>
                                <vx-action-icon class="mr-5" icon="LoaderIcon" spin />
                            </div>
                            <div v-else>
                                <span class="mr-5"> Waiting for the publisher to start </span>
                            </div>
                        </div>
                        <vx-action-icon
                            v-else
                            class="mr-5"
                            icon="UploadCloudIcon"
                            hover-color="blue"
                            @click.stop="publish"
                            tooltipPosition="bottom"
                            tooltip="Publish to Zutak"
                            :disabled="edition.isPublishing"
                        />
                    </li>
                    <li style="display: flex !important; justify-self: end">
                        <profile-drop-down />
                    </li>
                </ul>
            </vs-navbar>
        </div>
    </div>
</template>

<script>
import HNavMenuGroup from './HorizontalNavMenuGroup.vue'
import HNavMenuHeader from './HorizontalNavMenuHeader.vue'
import HNavMenuItem from './HorizontalNavMenuItem.vue'
import ProfileDropDown from '../navbar/components/ProfileDropDown.vue'
import { mapGetters } from 'vuex'

export default {
    components: {
        HNavMenuGroup,
        HNavMenuHeader,
        HNavMenuItem,
        ProfileDropDown
    },
    data() {
        return {}
    },
    computed: {
        ...mapGetters({ nav_menu_items: 'router/nav_menu_items' }),
        ...mapGetters({
            has_role: 'auth/has_role',
            edition: 'auth/edition'
        }),
        navbarColor() {
            return this.$store.state.theme === 'dark' ? '#10163a' : '#fff'
        },
        publishedItemCount() {
            if (!this.edition) {
                return 0
            }
            let count = this.edition.items
                .filter((x) => x.status == 3)
                .sum((x) => x.imageIdsCount + x.audioTracksCount + 1)
            return count
        },
        itemsToPublish() {
            if (!this.edition) {
                return 0
            }
            return this.edition.items.sum((x) => x.imageIdsCount + x.audioTracksCount + 1)
        },
        itemsScheduled() {
            if (!this.edition || !this.edition.nonScheduledItems) {
                return 0
            }
            return this.edition.nonScheduledItems.sum(
                (x) => x.imageIdsCount + x.audioTracksCount + 1
            )
        }
    },
    methods: {
        checkGrpChildrenActive(group) {
            const path = this.$route.fullPath
            let active = false
            const routeParent = this.$route.meta ? this.$route.meta.parent : undefined

            if (group.submenu) {
                group.submenu.forEach((item) => {
                    if (active) return true
                    if ((path == item.url || routeParent == item.slug) && item.url) {
                        active = true
                    } else if (item.submenu) {
                        this.checkGrpChildrenActive(item)
                    }
                })
            }

            return active
        },
        async publish() {
            try {
                this.notifySuccess(
                    'Publishing...',
                    'This could take a little while depending on how many changes need to be published',
                    7000
                )
                var response = await this.$api.content.publish()
            } catch (e) {}
        }
    }
}
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/components/horizontalNavMenu.scss';
.dropdown-wrapper {
    width: 300px;
}

.dropdown-list {
    list-style: none;
}

.dropdown-item {
    display: flex;
    justify-content: space-between;
    margin: 1rem;
}

.a-icon {
    outline: none;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16x;
}

.expand-icon {
    font-size: 1.5rem !important;
}
.custom-nav-height {
    max-height: 64px;
}
</style>
